import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';
import swal from 'sweetalert';
import Addresses from './Addresses';
import * as Utils from '../../../utils/utils';
import * as UserActions from '../../../actions/userActions';

import IntlTelInput from 'react-intl-tel-input';
import AllCountries from 'react-intl-tel-input/dist/components/AllCountries';
import 'react-intl-tel-input/dist/main.css';
import Loader from '../../../components/commons/loader/loader';
import Moment from 'moment';
class ProfileView extends Component {

  constructor(props) {
    super(props);
    this.state = {

      isPhoneVerified: false,
      isEmailVerified: false,
      show: false,
      nameEditable: false,
      dobEditable: false,
      emailEditable: false,
      phoneEditable: false,
      passwordEditable: false,
      firstName: '',
      lastName: '',
      dob: '',
      updateDob:'',
      email: '',
      phone: '',
      dialCode: '',
      iso: '',
      oldPassword: '',
      newPassword1: '',
      newPassword2: '',
      showAlert: false,
      swalParams: {
        title: ""
      },
      otp:"",
      customClass:""
    }

    this.renderNameEditRow = this.renderNameEditRow.bind(this);
    this.renderEmailEditRow = this.renderEmailEditRow.bind(this);
    this.renderDOBEditRow = this.renderDOBEditRow.bind(this);
    this.renderPhoneEditRow = this.renderPhoneEditRow.bind(this);
    this.renderPasswordEditRow = this.renderPasswordEditRow.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.updateDOBNumber = this.updateDOBNumber.bind(this);
    this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.renderAddressesRow = this.renderAddressesRow.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
    this.checkOtp = this.checkOtp.bind(this);
    this.resendOTP=this.resendOTP.bind(this);
    this.handleOnResendEmail = this.handleOnResendEmail.bind(this);

    this.handlePhoneChange = this.handlePhoneChange.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(UserActions.getProfileDetails(response => {
      const {data,status}=response;
      if (status) {
        let user = data;
        this.setState({
          firstName: user && user.name
            ? user.name.first
            : '',
          lastName: user && user.name
            ? user.name.last
            : '',
          email: user && user.email
            ? user.email
            : '',
          dob: user && user.dob
            ? user.dob
            : '',
          phone: user && user.phone
            ? user.phone
            : '',
          addresses: user
            ? user.addresses
            : [],
            dialCode: user && user.dialCode
            ? user.dialCode
            : '1',
            iso: user && user.iso
            ? user.iso
            : 'us',
        })
        if('isEmailVerified' in data && data.isEmailVerified == true ){

          this.setState({isEmailVerified:data.isEmailVerified});
        }
        if('isPhoneVerified' in data && data.isPhoneVerified == true ){
          
          this.setState({ isPhoneVerified: true });
          
        }
      } else {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Failed to load profile details, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))

    window.onkeydown = null;
  }

  render() {

    const {showAlert, swalParams,customClass} = this.state;
    const {loading} = this.props;
    console.log("PROFILE_VIEW_STATE", this.state);
    console.log("PROFILE_VIEW_PROPS", this.props);

    return (
      <div className="profile-view-container">
        {this.renderNameEditRow()}
        {this.renderEmailEditRow()}
        {this.renderDOBEditRow()}
        {this.renderPhoneEditRow()}
        {this.renderPasswordEditRow()}
        {this.renderAddressesRow()}
        
        <Loader visibility={loading} />
<SweetAlert
          customClass={customClass}
          show={this.state.show}
          title="Phone Verification"
          text="Enter your OTP"
          type="input"
          inputType="number"
          inputPlaceholder="Enter OTP"
          showCancelButton
          confirmButtonColor="#007792"
          cancelButtonText={"Resend"}
          confirmButtonText={'Submit OTP'}
          onOutsideClick={() => this.setState({ show: false })}
          
          onConfirm={(inputValue) => {
            

      
            if (inputValue === undefined || inputValue === null || inputValue === "") {
      swal.showInputError('You need to write something!');
      return;
    }
            this.checkOtp(inputValue);
            return;
          }}
          onEscapeKey={() => this.setState({ show: false })}
          onCancel={
            this.resendOTP
          }
        />
      
        <SweetAlert customClass={customClass} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams}  
          
          onEscapeKey={() => this.setState({ showAlert: false })}
          onOutsideClick={() => this.setState({ showAlert: false })}/>
      </div>
    )
  }

  renderNameEditRow() {

    const {nameEditable, firstName, lastName} = this.state;
    let isFormValid = !!firstName;
    return (
      <div className="row">
        <div className="col-md-12">
          <label for="firstName">Name</label>
          {/* <a href="javascript:void(0)" className="link" onClick={() => this.setState({
            nameEditable: !nameEditable
          })}>{!nameEditable
              ? 'Edit'
              : 'Cancel'}</a> */}
        </div>
        <div className="col-md-4">
          <input type="text" placeholder="First Name" aria-label="First Name" disabled={!nameEditable
            ? 'disabled'
            : null} value={firstName} onChange={(e) => this.setState({firstName: e.target.value})}/>
        </div>
        <div className="col-md-4">
          <input type="text" placeholder="Last Name" aria-label="Last Name" disabled={!nameEditable
            ? 'disabled'
            : null} value={lastName} onChange={(e) => this.setState({lastName: e.target.value})}/>
        </div>
        <div className="col-md-4">
          {nameEditable
            ? (
              <div className={`button button-block ${isFormValid
                ? ''
                : 'disabled'}`} onClick={() => isFormValid
                ? this.updateProfile()
                : null}>SAVE</div>
            )
            : null}
        </div>
      </div>
    )
  }

  renderEmailEditRow() {

    const {emailEditable, email,isEmailVerified} = this.state;
    return (
      <div className="row">
        <div className="col-md-12">
          <label for="Email Address">Email Address</label> {isEmailVerified?<span className="span-text">&#9989; Verified</span>:<a className="link" href="javascript:void(0)" onClick={this.handleOnResendEmail} >Verify Email</a> }
        </div>
        <div className="col-md-8">
          <input type="text" placeholder="Email Address" aria-label="Email Address" disabled value={email}/>
        </div>
      </div>
    )
  }
  
  renderDOBEditRow() {
    const {dobEditable,dob,updateDob} = this.state;
    let isFormValid = !!dob;
    if(dob=="1000-12-01"){
    return (
      <div className="row">
        <div className="col-md-12">
          <label>DOB</label>
          <a href="javascript:void(0)" className="link" onClick={() => this.setState({
            dobEditable: !dobEditable
          })}>{!dobEditable
              ? 'Edit'
              : 'Cancel'}</a>
        </div>
        <div className="col-md-8">
          <input type="date" placeholder="DOB" disabled={!dobEditable
            ? 'disabled'
            : null}  aria-label="DOB" onChange={(e) => this.setState({updateDob: e.target.value})}/>
        </div>
        <div className="col-md-4">
          {dobEditable
            ? (
              <div className={`button button-block ${isFormValid
                ? ''
                : 'disabled'}`} onClick={() => isFormValid
                ? this.updateDOBNumber()
                : null}>SAVE</div>
            )
            : null}
        </div>
      </div>
    )}
    return null;
  }

  renderPhoneEditRow() {
    const {phoneEditable, phone,isPhoneVerified,dialCode,iso} = this.state;
    let isFormValid = Utils.isPhoneNumberValid(phone);
    return (
      <div className="row">
        <div className="col-md-12">
          <label>Phone Number</label> {isPhoneVerified?<span className="span-text">&#9989; Verified</span>:phone?<a className="link" href="javascript:void(0)" onClick={this.resendOTP } >Verify Phone </a>: ""}{phone?`|`:""}
          <a href="javascript:void(0)" className="link" onClick={() => this.setState({
            phoneEditable: !phoneEditable
          })}>{!phoneEditable
              ? 'Edit'
              : 'Cancel'}</a>
        </div>
        <div className="col-md-8">
        {iso?<IntlTelInput 
                    containerClassName="intl-tel-input"
                    inputClassName="form-control"
                    name="mobile"
                    placeholder="Enter Your Phone Number"
                    input
                    type="tel"
                    value={phone}
                    preferredCountries={[iso]}
                    separateDialCode={false}
                    formatOnInit={false}
                    disabled={!phoneEditable
                      ? true
                      : false}
                    onPhoneNumberChange={this.handlePhoneChange}
                    onPhoneNumberBlur={this.handlePhoneChange}
                    aria-label="Phone Number"
                  
    />:""}
        </div>
        <div className="col-md-4">
          {phoneEditable
            ? (
              <div className={`button button-block ${isFormValid
                ? ''
                : 'disabled'}`} onClick={() => isFormValid
                ? this.updatePhoneNumber()
                : null}>SAVE</div>
            )
            : null}
        </div>
      </div>
    )
  }

  renderPasswordEditRow() {
    const {passwordEditable, oldPassword, newPassword1, newPassword2} = this.state;
    let isFormValid = oldPassword && newPassword1 && newPassword2 && newPassword1 === newPassword2;
    return (
      <div className="row">
        <div className="col-md-12">
          <label>Password</label>
          <a href="javascript:void(0)" className="link" onClick={() => this.setState({
            passwordEditable: !passwordEditable
          })}>{!passwordEditable
              ? 'Edit'
              : 'Cancel'}</a>
        </div>
        <div className="col-md-12">
          {passwordEditable
            ? (
              <div className="row">
                <div className="col-md-4">
                  <input type="password" placeholder="Old Password" aria-label="Old Password" onChange={(e) => this.setState({oldPassword: e.target.value})} value={oldPassword}/>
                </div>
                <div className="col-md-8"></div>
                <div className="col-md-4">
                  <input type="password" placeholder="New Password" aria-label="New Password"  onChange={(e) => this.setState({newPassword1: e.target.value})} value={newPassword1}/>
                </div>
                <div className="col-md-8"></div>
                <div className="col-md-4">
                  <input type="password" placeholder="New Password Repeat" aria-label="New Password Repeat" onChange={(e) => this.setState({newPassword2: e.target.value})} value={newPassword2}/>
                </div>
                <div className="col-md-8">
                  <div className={`button button-block ${isFormValid
                    ? ''
                    : 'disabled'}`} onClick={() => isFormValid
                    ? this.changePassword()
                    : null}>SAVE</div>
                </div>
              </div>
            )
            : null}
        </div>
      </div>
    )
  }

  renderAddressesRow() {

    const {addressesEditable, addresses} = this.state;

    return (
      <div className="row">
        <div className="col-md-12">
          <label>Addresses Management</label>
          <a href="javascript:void(0)" className="link" onClick={() => this.setState({
            addressesEditable: !addressesEditable
          })}>{!addressesEditable
              ? 'Edit'
              : 'Cancel'}</a>
        </div>
        <div className="col-md-12">
          {addressesEditable
            ? (<Addresses {...this.props} addresses={addresses} onDeleteAddress={this.deleteAddress}/>)
            : null}
        </div>
      </div>

    )
  }

  updateProfile() {

    const {firstName, lastName, email} = this.state;

    let tempUser = {
      name: {
        first: firstName,
        last: lastName
      },
      email: email,
    }
    this.props.dispatch(UserActions.saveProfileDetails(tempUser, response => {
      if (response.status) {
        let user = response.data;
        this.setState({
          firstName: user && user.name
            ? user.name.first
            : '',
          lastName: user && user.name
            ? user.name.last
            : '',
          email: user && user.email
            ? user.email
            : '',
        }, () => {
          this.setState({
            showAlert: true,customClass:"with-close",
            swalParams: {
              title: 'Profile saved successfully!',
              type: "success",
              showConfirmButton: false
            }
          })
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        })
      } else {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Failed to save profile, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }
  updateDOBNumber() {
    const {updateDob} = this.state;
    let formattedDob = Moment(updateDob).format("MM/DD/YYYY");
    let ageData = Utils.calculateAge(formattedDob);
    
    if (ageData.status == 0) {
      if (ageData.age < 21) {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Sorry! you are too young!',
            type: "error",
            showConfirmButton: false
          }
        });
        return;
      }}
    let tempUser = {
     
      dob: updateDob,
    }
    this.props.dispatch(UserActions.saveProfileDetails(tempUser, response => {
      if (response.status) {
        let user = response.data;
        this.setState({
          dob: user && user.dob
            ? user.dob
            : '',
        }, () => {
          this.setState({
            showAlert: true,customClass:"with-close",
            swalParams: {
              title: 'DOB saved successfully!',
              type: "success",
              showConfirmButton: false
            }
          })
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        })
      } else {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Failed to save DOB, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))

  }
  updatePhoneNumber() {

    const { phone,dialCode,iso} = this.state;
// console.log("iso is",iso)
    let tempUser = {
      phone: phone,
      dialCode:dialCode,
      iso:iso,

      isPhoneVerified: false ,
    }
    console.log("updatePhoneNumbertempUser",tempUser)
    this.props.dispatch(UserActions.saveProfileDetails(tempUser, response => {
      if (response.status) {
        let user = response.data;
        console.log("phoneupdated",user);
        this.setState({
          isPhoneVerified:  user && user.isPhoneVerified
          ? user.isPhoneVerified
          : false ,
          phone: user && user.phone
            ? user.phone
            : '',
            dialCode: user && user.dialCode
              ? user.dialCode
              : '',
            iso: user && user.iso
              ? user.iso
              : '',
        }, () => {
          this.setState({
            showAlert: true,customClass:"with-close",
            swalParams: {
              title: 'Phone number saved successfully!',
              type: "success",
              showConfirmButton: false
            }
          })
          // setTimeout(() => this.setState({showAlert: false}), 2000);
        })
      } else {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Failed to save phone number, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }

  changePassword() {
    const {oldPassword, newPassword1, email} = this.state;

    let resetPasswordData = {
      email: email,
      password: newPassword1,
      oldPassword: oldPassword
    }
    this.props.dispatch(UserActions.changePasswordRequest(resetPasswordData, response => {
      if (response.status) {
        this.setState({
          showAlert: true,customClass:"with-close",
          oldPassword: '',
          newPassword1: '',
          newPassword2: '',
          swalParams: {
            title: 'Password changed successfully!',
            type: "success",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      } else {
        let message = response.data.message
          ? response.data.message
          : 'Something went wrong, please try again later!';
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: message,
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }
  handleOnResendEmail() {
    const { dispatch } = this.props;
    this.setState({ success: false, error: false});
    dispatch(UserActions.resendVerifyEmail({}, ({ status }) => {
        this.setState({ success: status, error: !status,  showAlert: true,customClass:"with-close", swalParams: {
          title: "Verification Email sent successfully",
          type: "success",
          showConfirmButton: false,
          
        } });
    }));
  }
  checkOtp(inputValue) {
    
    this.setState({ success: false, error: false });
    this.props.dispatch(UserActions.setVerifyOTP({ otp: inputValue}, response => {
      
      if(response.status) {
        this.setState({customClass:"with-close",isPhoneVerified: true,showAlert: true,swalParams: {
          title: "OTP confirmed successfully",
          type: "success",

          confirmButtonColor:"#007792",
          showConfirmButton: true,
          onConfirm: () => {
            this.setState({show:false,showAlert: false});

            // this.props.history.push('/settings?edit=profile');
          },
          onCancel: () => {
            this.setState({show:false,showAlert:false});
            // this.props.history.push('/settings?edit=profile');
           },
           onOutsideClick: () => {
            this.setState({show:false,showAlert:false});
            // this.props.history.push('/settings?edit=profile');
           },
        }})
      } else {
        this.setState({customClass:"with-close",showAlert: true, swalParams: {
          title: "OTP failed, please try again later!",

          confirmButtonColor:"#007792",
          type: "error",
          showConfirmButton: true,
          onConfirm: () => {
            this.setState({showAlert:false});

            setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
            // this.props.history.push('/');
          },
          onCancel: () => {
            this.setState({show:false,showAlert:false});
            // this.props.history.push('/');
           },
           onOutsideClick: () => {
            this.setState({show:false,showAlert:false});
            // this.props.history.push('/');
           }
        }})
      }
    }))
  }
  handlePhoneChange (status, phoneNumber, country){
    let dialCode=country.dialCode;
    let iso=country.iso2;
        
        this.setState({phone: phoneNumber,dialCode:dialCode,iso:iso});
      }
      resendOTP(){
    
        const { dispatch } = this.props;
        this.setState({ success: false, error: false });
        dispatch(UserActions.resendVerifyOTP({}, ({ status, data}) => {
          // console.log("resendVerifyOTP",status);
          // console.log("resendVerifyOTP",data);
    
           if(status){ 
             this.setState({ customClass:"with-close",success: status, error: !status,  showAlert: true , swalParams: {
              title: "OTP sent successfully",
              type: "success",
              confirmButtonColor:"#007792",
              showConfirmButton: true,
              onConfirm: () => {
                this.setState({showAlert: false});
                setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
                // this.props.history.push('/');
              },
              onCancel: () => {
                this.setState({show:false,showAlert:false});
                setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
                // this.props.history.push('/');
               },
               onOutsideClick: () => {
                this.setState({show:false,showAlert:false});
                // this.props.history.push('/');
               }
            }});}else{
              this.setState({customClass:"with-close",showAlert: true, swalParams: {
                title: "Resend OTP failed, please try again later!",
      
                confirmButtonColor:"#007792",
                type: "error",
                showConfirmButton: true,
                onConfirm: () => {
                  this.setState({showAlert:false});
      
                  setTimeout(() => this.setState({show: true,customClass:"otp-verification"}), 1000);
                  // this.props.history.push('/');
                },
                onCancel: () => {
                  this.setState({show:false,showAlert:false});
                  // this.props.history.push('/');
                 },
               onOutsideClick: () => {
                this.setState({show:false,showAlert:false});
                // this.props.history.push('/');
               }
              }})
            }
    
    
        }));
      }
  deleteAddress(address) {

    this.props.dispatch(UserActions.deleteUserAddress({
      id: address._id
    }, response => {
      console.log("ADDRESS_DELETE_RESPONSE", response);
      if (response.status) {
        let addresses = response.data.addresses;
        this.setState({addresses});
      } else {
        this.setState({
          showAlert: true,customClass:"with-close",
          swalParams: {
            title: 'Failed to delete address, please try again later!',
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }));
  }

}

export default connect((state) => {
  return {
    user: state.getIn(['users', 'user']),
    loading: state.getIn(['users', 'loading']),
    error: state.getIn(['users', 'error'])
  };
})(ProfileView);



// WEBPACK FOOTER //
// ./src/containers/settings/profile/ProfileView.js